/* @flow */

import { callApiEndpoint } from './index';
import utils from './utils';

import type { Producer } from 'types';

const find = async (): Promise<Producer[]> => {
  const endpoint = 'produttori/findAll';
  const response = await callApiEndpoint(endpoint, { method: 'POST', body: {} });
  return response.map(utils.toProducer);
};

export default {
  find,
};
